import { styled } from "@mui/material/styles";
import Menu, { MenuProps } from "@mui/material/Menu";
import { useAppDispatch } from "../../hooks";
import { useEffect } from "react";
import { setOpenModal } from "../../features/companySlice";

export const StyledMenu = styled((props: MenuProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setOpenModal(props.open));
    return () => {
      dispatch(setOpenModal(false));
    };
  }, [props.open]);

  return (
    <Menu
      autoFocus={false}
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  );
})(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px," +
      " rgba(0, 0, 0, 0.05) 0px 0px 0px 1px," +
      " rgba(0, 0, 0, 0.1) 0px 10px 15px -3px," +
      " rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: "transparent",
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));
